import { SVGProps } from 'react';

const SvgCreditCard = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M3.163 9.93c-.09-.336.117-.77.588-.896l13.91-3.727c.471-.127.867.146.957.483l1.368 5.105-15.455 4.142L3.163 9.93Zm1.886 7.038 15.455-4.14.333 1.241c.09.337-.116.77-.588.897l-13.91 3.727c-.471.127-.867-.146-.957-.483l-.333-1.242Zm17.387-4.658.332 1.242c.4 1.491-.553 2.958-2.002 3.346L6.857 20.625c-1.449.388-3.007-.405-3.407-1.897l-.333-1.242-.517-1.932-1.368-5.106c-.4-1.491.553-2.958 2.002-3.346l13.909-3.727c1.449-.388 3.007.405 3.407 1.897l1.368 5.106.518 1.932Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgCreditCard;
